<template>
  <div v-if="cartCount > 0">
    <form data-name="minicart-content" class="d-flex flex-column" action="#" method="POST">
      <h4 v-if="icon.dropHeading" class="border-bottom border-black fs-5 text-black text-uppercase mb-3 px-2 pb-3">{{ $t("shopping_cart_count_1") }} <span class="text-primary minicart-count">{{ this.cartCount }}</span> {{ this.cartCount > 1 ? $t("shopping_cart_count_3") : $t("shopping_cart_count_2") }}</h4>
      <div class="minicart-items mb-4">
        <div class="row mb-3" v-for="dropItem of icon.dropItems" :key="dropItem.product.sku">
          <div class="col-auto">
            <b-link :to="`/${dropItem.product.url_key}`">
              <img class="product-img border border-secondary" :src="dropItem.product.thumbnail.thumbnail" width="110" alt="HEMD-52 bLAUW slim FIT OPSTAANDE">
            </b-link>
          </div>
          <div class="col-auto py-1">
            <div class="d-flex flex-column justify-content-between h-100">
              <h6 class="fs-5 mb-2"><b-link :to="`/${dropItem.product.url_key}`" class="text-secondary minicart-productname">{{ dropItem.product.name }}</b-link></h6>
              <span v-if="dropItem.product.stock_status == 'IN_STOCK'" class="d-block in-stock text-success mb-2">{{ $t("in_stock") }}</span>
              <span v-else class="d-block in-stock text-danger mb-2">{{ $t("item_out_of_stock") }}</span>
              <div class="d-flex justify-content-between">
                <div class="minicart-item-qty">
                  <div class="input-group">
                    <button class="btn minicart-ince" type="button" @click.stop="quantityDown(dropItem.id, dropItem.quantity)">-</button>
                    <input type="text" min="1" class="form-control" placeholder="Qty" aria-label="Product Quantity" :value="dropItem.quantity" name="quantity" ref="inputQuantity" disabled>
                    <button class="btn minicart-decr" type="button" @click.stop="increaseQty(dropItem.id, dropItem.quantity)">+</button>
                  </div>                      
                </div>
                <div class="minicart-item-price fs-5 fw-bold text-primary">{{
                  formatCurrency(
                    dropItem.prices.row_total_including_tax.value
                  )
                }}</div>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <a class="minicart-remove-item d-inline-block mt-4 px-1" @click.stop="removeCartItem(dropItem.id)"><ClientOnly><i class="fa-solid fa-xmark fa-2xl"></i></ClientOnly></a>
          </div>
        </div>
      </div>
      <table class="minicart-total table table-borderless align-self-end fw-bold text-end">
        <tbody>
        <tr>
          <td>{{ $t("subtotal_btw") }}:</td>
          <td class="text-primary minicart-btw-subtotal">{{ formatCurrency(cartTotalWithTax) }}</td>
        </tr>
        <tr v-for="(discount, index) in cartTotalDiscounts" :key="index">
          <td>{{ discount.label }}:</td>
          <td class="text-primary">- {{ formatCurrency(discount.amount.value) }}</td>
        </tr>
        <tr class="border-top border-black fs-5">
          <td>{{ $t("total_btw") }}:</td>
          <td class="text-primary minicart-subtotal">{{ formatCurrency(cartTotalPrice) }}</td>
        </tr>
        </tbody>
      </table>
      <b-link @click.stop="goCart">{{ $t("goto_cart") }}</b-link>
      <button class="btn btn-primary btn-lg align-self-end minicart-placeorder" type="button" @click.stop="goCheckout" v-bind:disabled="btnDisable">{{ icon.cartFooter.btnText }}</button>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Cart from "@storefront/core/modules/cart/mixins";
import getImageUrl from "@/esf_antarctica_lederhosenland/helpers/getImageUrl.js";
import ClientOnly from "vue-client-only";
export default {
  name: "HeaderIconsDropdown",
  props: {
    icon: {
      type: Object,
    },
    showType: { type: String },
    visible: { type: Boolean },
  },
  mixins: [Cart],
  components: {
    ClientOnly
  },
  computed: {
    btnDisable() {
      if (this.cartCount > 0) {
        return false;
      } else {
        return true;
      }
    },
    cartTotalWithOutTax: function () {
      if (this.$store.getters["cart/getCartIsLoaded"] == true) {
        const prices = this.$store.getters["cart/getCartPrices"];
        if (typeof prices != "undefined") {
          if (typeof prices.subtotal_excluding_tax != "undefined") {
            if (typeof prices.subtotal_excluding_tax.value != "undefined") {
              return prices.subtotal_excluding_tax.value;
            }
          }
        }
        return 0;
      } else {
        return 0;
      }
    },
    cartTotalWithTax: function () {
      if (this.$store.getters["cart/getCartIsLoaded"] == true) {
        const prices = this.$store.getters["cart/getCartPrices"];
        if (typeof prices != "undefined") {
          if (typeof prices.subtotal_including_tax != "undefined") {
            if (typeof prices.subtotal_including_tax.value != "undefined") {
              return prices.subtotal_including_tax.value;
            }
          }
        }
        return 0;
      } else {
        return 0;
      }
    },
  },
  created() {},
  mounted() {
    // document.addEventListener("click", this.closeDropdownMenu);
  },
  destroyed() {
    // document.removeEventListener("click", this.closeDropdownMenu);
  },
  data() {
    return {
      // visible: false,
    };
  },
  methods: {
    ...mapActions(["setProductStatus"]),
    formatCurrency(value) {
      var formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(value);
    },
    goCart() {
      // this.visible = false;
      this.$router.push("/checkout/cart");
    },
    goCheckout() {
      // this.visible = false;
      this.$router.push("/checkout");
    },
    async increaseQty(id, quantity) {
      const isQtyAvailable = await this.checkAvailableQty(id, quantity);
      if (isQtyAvailable) {
        this.quantityUp(id, quantity);
      }
    },
    removeCartItem(id) {
      const cartItems = this.cartItems.filter((v) => v.id != id);
      const isCheckoutRoute = this.$route.name === "checkout";
      if (isCheckoutRoute && cartItems.length === 0) {
        this.removeItem(id);
        this.$router.push("/checkout/cart");
      } else {
        this.removeItem(id);
      }
    },
    async checkAvailableQty(id, qty) {
      const cartItem = this.cartItems.find((v) => v.id == id);

      if (!cartItem.product.backorders_allowed) {
        if (typeof cartItem.product.stock_qty != "undefined") {
          if (cartItem.product.stock_qty > qty) {
            return true;
          } else {
            const msg = {
              type: "danger",
              title: this.$t("shopping_basket"),
              text: this.$t("product_not_in_stock_msg", {
                numberOf: cartItem.stock_qty,
              }),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
            return false;
          }
        }
      }
      return true;
    },
    closeDropdownMenu(e) {
      if (!this.$el.parentElement.contains(e.target)) {
        // this.visible = false;
        this.$emit("close");
      }
    },
    imgUrl(fileName) {
      return getImageUrl(fileName);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
